import { truncateAtWord } from './plain-text.js'

/**
 * Comment notification text on the device (GH #2795, spec docs/ux/2026-10-25-comment-notifications.md §3, §4), shared
 * by the service worker (push, cut to 120) and the in-app toast (cut to 140).
 */

/** One comment: the server's title, and its text cut to this channel's length */
export const commentNotificationText = ({ title, body, limit }: { title: string; body: string; limit: number }) => ({
  title,
  body: truncateAtWord(body, limit),
})

/**
 * More comments in the same thread: N12 "{n} new comments in {Place}", and N13, the latest prefixed "{Author}: ".
 * Without a place the title drops it, as N7 does.
 */
export const groupedCommentText = ({
  count,
  place,
  author,
  text,
  limit,
}: {
  count: number
  place?: string
  author?: string
  text: string
  limit: number
}) => ({
  title: place ? `${count} new comments in ${place}` : `${count} new comments`,
  body: truncateAtWord(author ? `${author}: ${text}` : text, limit),
})
